import React, {useEffect, useState} from 'react';
import {Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Spinner} from 'reactstrap';
import {doc, getDoc, updateDoc} from "firebase/firestore";
import {getDb} from "../../util/Constants";


function EditRegion(props) {
    const [region, setRegion] = useState("");
    const [load, setLoad] = useState(false);

    useEffect(()=>{
        fetchRegion()
    },[])

    const fetchRegion= async()=>{

        const docRef = doc(getDb(), "regions",props?.item?.id );
        const querySnapshot = await getDoc(docRef);
        const _region = querySnapshot.data();
        setRegion(_region.region)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoad(true);
        const docRef = doc(getDb(), "regions", props?.item?.id);
        let dataCapital=region.charAt(0).toUpperCase() + region.slice(1)
        await updateDoc(docRef, {
            region: dataCapital
        });
        props.getRegions();
        setLoad(false)
        props.toggle()
        setRegion("")
    };




    return (
        <div>

            <Modal isOpen={props.modal} toggle={props.toggle}>
                <ModalHeader toggle={props.toggle}>Edit Department</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit}>

                        <div className="">

                            <FormGroup>
                                <Label for="department">
                                    Region Name
                                </Label>
                                <Input
                                    type="text"
                                    id="department"
                                    maxLength={20}
                                    value={region}
                                    required
                                    className="form-control-alternative"
                                    onChange={(e) => setRegion(e.target.value)}
                                />

                            </FormGroup>
                        </div>

                        <Button color="primary" type="submit" disabled={load}>
                            {load ? (
                                <Spinner color="light" size="sm" />
                            ) : (
                                "Save"
                            )}

                        </Button>
                        <Button color="secondary" onClick={props.toggle}>
                            Cancel
                        </Button>
                    </Form>
                </ModalBody>

            </Modal>
        </div>);
}


export default EditRegion;